import { Component, Input } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { NumberInputConfig } from '../input.type';

/**
 * Number input component.
 * @param min - The minimum number.
 * @param max - The maximum number.
 * @param format - The format of the number.
 * @param decimals - The number of decimals.
 * @param maxLength - The maximum length of the number.
 * @param showSpinners - Whether to show spinners(Up and Down arrows) in edit mode.
 */
@Component({
    selector: 'app-number-input',
    templateUrl: './number-input.component.html',
    providers: [{ provide: BaseInputComponent, useExisting: NumberInputComponent }]
})
export class NumberInputComponent extends BaseInputComponent<number> {
    @Input() min: NumberInputConfig['min'] = 0;
    @Input({ required: true }) max: NumberInputConfig['max'];
    @Input({ required: true }) format: NumberInputConfig['format'] = '#';
    @Input({ required: true }) decimals: NumberInputConfig['decimals'];
    @Input() maxLength: NumberInputConfig['maxLength'];
    @Input() showSpinners: NumberInputConfig['showSpinners'] = false;
}
